type ReadFieldFunction = (fieldName: string, object?: any) => any;
type MergeObjectsFunction = (existing: any, incoming: any) => any;

/**
 * Merge array by unique field value. ex) id, nodeId, etc.
 */
export function mergeArrayByField<T>(fieldName: string) {
  return function (
    existing: T[] | undefined,
    incoming: T[] | undefined,
    { readField, mergeObjects }: { readField: ReadFieldFunction; mergeObjects: MergeObjectsFunction },
  ): T[] {
    const merged: T[] = existing ? existing.slice(0) : [];

    incoming?.forEach((item, _index) => {
      const fieldValue = readField(fieldName, item);

      const existingIndex = merged.findIndex((m) => (m as Record<string, unknown>)[fieldName] === fieldValue);
      if (existingIndex !== -1) {
        merged[existingIndex] = mergeObjects(merged[existingIndex], item);
      } else {
        merged.push(item);
      }
    });

    return merged;
  };
}
